<div class="card-container">
	<mat-card class="example-card">
		<mat-card-header>
			<mat-card-title class="fl">{{accion}} documento</mat-card-title>
			<mat-card-subtitle></mat-card-subtitle>
		</mat-card-header>

		<mat-card-content>
			<div class="spinner" *ngIf="isLoading">
				<mat-spinner color="accent"></mat-spinner>
			</div>
			<form novalidate [formGroup]="form">
				<div class="row">
					<mat-form-field appearance="fill" class="input-full-w">
						<mat-label>NOMBRE DEL DOCUMENTO</mat-label>
						<input type="text" matInput maxlength="250" #nombre_doc formControlName="nombre_doc">
						<mat-hint align="end">{{nombre_doc.value.length}} / 250</mat-hint>
						<mat-error *ngIf="form.controls['nombre_doc'].hasError('maxlength')">
							El maximo tamaño es de 250 caracteres
						</mat-error>
					</mat-form-field>
				</div>
				<div class="row">
					<mat-form-field appearance="fill">
						<mat-label>Adjuntar documento</mat-label>
						<input matInput readonly matInput placeholder="Adjuntar PDF">
						<button mat-icon-button type="button" (click)="file.click()" matSuffix>
							<mat-icon>attach_file</mat-icon>
						</button>
						<input type="file" #file class="hide"  (change)="onchangeArchivo_org($event)"/>
					</mat-form-field>
				</div>
			</form>

			<div class="mt-5 d-flex justify-content-center">
				<div *ngIf="form.invalid || !file">
					<span class="text-danger">
						Faltan campos por llenar
					</span>
				</div>
			</div>

			<div class="d-flex justify-content-center gap-2">

				<button class="flat" color="primary" mat-flat-button [routerLink]="['/rrhh/gestor-de-puestos-de-trabajo/gestor-organigrama-docs']" >
					Regresar
				</button>

				<form novalidate [formGroup]="form" *ngIf="accion == 'registrar'" (ngSubmit)="postRegistrarDocumentosOrg()">
					<button *ngIf="file" class="flat" color="primary" mat-flat-button type="submit" [disabled]="form.invalid">
						Guardar
					</button>
				</form>
				<form novalidate [formGroup]="form" *ngIf="accion == 'modificar'" (ngSubmit)="postModificarDocumentosOrg()" >
					<button class="flat" color="primary" mat-flat-button type="submit" [disabled]="form.invalid">
						Modificar
					</button>
				</form>

			</div>
		</mat-card-content>
	</mat-card>
</div>
